import { Menu, MenuProps, styled } from '@mui/material';

export const StyledMenu = styled(Menu)<MenuProps>`
  .MuiTypography-root {
    font-size: 0.875rem;
    letter-spacing: ${({ theme }) => theme.spacing(0.02125)};
  }
`;
